import { connect } from 'react-redux'

import AddNewPatient from './AddNewPatient'
import { getAddNewPatientData, handleOnNewPatientFormSubmit } from './module'
import { getDataSource } from '../../store/appReducer'
import { DATASOURCES } from '../../constants'

const mapActionCreators = {
  handleOnNewPatientFormSubmit,
  getAddNewPatientData,
}

const mapStateToProps = state => ({
  dataIsFetching: state.addNewPatient.dataIsFetching,
  dataLastUpdated: state.addNewPatient.dataLastUpdated,
  patient: getDataSource(state, DATASOURCES.PATIENT),
  patients: getDataSource(state, DATASOURCES.PATIENTS),
  physicians: getDataSource(state, DATASOURCES.PHYSICIANS),
  me: getDataSource(state, DATASOURCES.ME),
  medantaUHIDValidation: state.addNewPatient.medantaUHIDValidation,
})

export default connect(
  mapStateToProps,
  mapActionCreators
)(AddNewPatient)



// WEBPACK FOOTER //
// ./src/legacy/pages/AddNewPatient/container.js